(function () {

    "use strict";

    angular
        .module('harriApp')
        .controller("ViewRemoteClockAttemptsModalController", ViewRemoteClockAttemptsModalController);

    ViewRemoteClockAttemptsModalController.$inject = ['$scope', 'modalData', 'googleMaps'];

    function ViewRemoteClockAttemptsModalController($scope, modalData, googleMaps) {

        let self = this;
        let employeeAttempt = modalData.employeeAttempt;
        self.attemptText = employeeAttempt.attemptText;
        self.eventTime = employeeAttempt.event_time;
        let userLocation = {
            latitude: employeeAttempt.geo_detail.latitude,
            longitude: employeeAttempt.geo_detail.longitude,
        };
        let geoFenceLocation = employeeAttempt.geo_detail?.brand_remote_clock_rule?.geo_fencing;

        self.close = () => {
            $scope.$hide();
        };

        let drawMarkers = (lat, lng) => {
            googleMaps.placeMarkerAndPanTo({
                lat: parseFloat(lat),
                lng: parseFloat(lng)
            }, googleMaps.map);
        };

        const getRadiusValueInMeters = (radius, radiusUnitCode) => {
            if (radiusUnitCode === 'INCHES') {
                return (radius / 12) * 0.3048;
            } else {
                return radius / 100;
            }
        };

        const init = ()=> {
            self.loading = true;
            googleMaps.googleServicePromise()
                .then(() => {
                    self.loading = false;
                     setupMap();
                })
                .catch(error => {
                    console.error("Failed to load Google Maps:", error);
                    self.loading = false;
                });
        }
        
       const drawLocation = (location, config) => {
            const locationLatLng = new google.maps.LatLng(parseFloat(location.latitude), parseFloat(location.longitude));
            new google.maps.Circle({
                strokeColor: config.color,
                strokeOpacity: config.strokeOpacity,
                strokeWeight: config.strokeWeight,
                fillColor: config.color,
                fillOpacity: config.fillOpacity || 1,
                map: self.mapObj,
                center: locationLatLng,
                radius: config.radius
            });
        }


        const setupMap = () => {
            const mapElement = $('#remote-clock-attempts-map');
            const centerLocation = geoFenceLocation || userLocation;
            googleMaps.initMap({
                element: mapElement,
                zoom: 10,
                center: {
                    lat: parseFloat(centerLocation.latitude),
                    lng: parseFloat(centerLocation.longitude)
                }
            }, (map) => {
                self.mapObj = map;
                drawLocation(userLocation, {
                    color: '#007bff',
                    strokeOpacity: 0,
                    strokeWeight: 0,
                    radius: 5 });
                if (geoFenceLocation) {
                    drawLocation(geoFenceLocation, {
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        color: '#0000FF',
                        fillOpacity: 0.20,
                        radius: getRadiusValueInMeters(geoFenceLocation.radius,geoFenceLocation.radius_unit)
                    });
                    drawMarkers(geoFenceLocation.latitude, geoFenceLocation.longitude);
                }
            });
        }

        init();
    }

})();

window.ViewRemoteClockAttemptsModal = (modalData) => {
    return {
        controller: 'ViewRemoteClockAttemptsModalController',
        controllerAs: '$ctrl',
        templateUrl: '../modules/team_schedule/employer/clock_time/modals/view-remote-clock-attempts/view-remote-clock-attempts.modal.html',
        show: true,
        backdrop: 'static',
        resolve: {
            modalData: modalData
        }
    };
};